import { userRoles } from 'src/services/constants';

/**
 * Returns all of the users with the accountRole of "admin".
 *
 * @param {Object} state
 * @returns {Array}
 */
export function admins(state, getters) {
  return getters.usersAsArray.filter(({ accountRole }) => accountRole === userRoles.ADMIN);
}

/**
 * Returns all users as an Array.
 *
 * @param {Object} state
 * @returns {Array}
 */
export function usersAsArray(state) {
  return Object.values(state.users);
}
